module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-BoldItalic-9c8c055c07a203b033583ecb82aa4eb0.ttf";